window.addEventListener("hoContentLoaded", () => {

	Vue.component('image-flip', {
		data: () => ({
			isFlipped : false
		}),

		methods: {
			select()
			{
				this.isFlipped = !this.isFlipped;

				if(this.isFlipped)
				{
					gsap.to(this.$refs.wrapper, 0.9, {
						rotateY: 180,
						ease: "power2.out",
						keyframes: [{
							z: -500,
							duration: 0.65
						}, {
							z: 0,
							duration: 0.65
						}],
					});

					gsap.to(this.$refs.icon, 1.3, {
						keyframes: [{
							z: -250,
							duration: 0.6
						}, {
							z: 0,
							duration: 0.6
						}],
						rotateY: 180,
						ease: "power3.out"
					});
				}
				else
				{
					gsap.to(this.$refs.wrapper, 0.9, {
						rotateY: 0,
						ease: "power2.out",

						keyframes: [{
							z: -500,
							duration: 0.65
						}, {
							z: 0,
							duration: 0.65
						}],
					});

					gsap.to(this.$refs.icon, 1.3, {
						keyframes: [{
							z: -250,
							duration: 0.6
						}, {
							z: 0,
							duration: 0.6
						}],
						rotateY: 0,
						ease: "power3.out"
					});
				}


			}
		},

		mounted()
		{

		}
	});
});
